import { SBOM_CONSTANTS } from '../../components/SBOM/SBOM.constants';
import { CONSTANTS } from '../../constants/constants';
const { ROWS } = CONSTANTS.TABLE.SBOM_TABLE;

export const SBOM_TABLE_CONSTANTS = {
  PACKAGE_MANAGER: 'Package Manager',
  PACKAGE: 'PACKAGE',
  GROUPED_BY: [
    { value: 'vendor', label: 'Group By Vendor' },
    { value: 'license', label: 'Group By License' },
    { value: 'type', label: 'Group By Type' },
    { value: 'subtype', label: 'Group By Package Manager' }
  ],
  vendor: {
    COLUMNS: [
      {
        title: { value: ROWS.VENDOR },
        name: 'vendor'
      },
      {
        title: { value: ROWS.COMPONENTS },
        name: 'components',
        type: 'number'
      },
      {
        title: { value: ROWS.LICENSES },
        name: 'licenses',
        type: 'number'
      },
      {
        title: { value: ROWS.CVES },
        name: 'vulnerability',
        hideFilter: true
      },
      {
        title: { value: ROWS.EXPLOITS },
        name: 'exploit',
        hideFilter: true
      }
    ]
  },
  license: {
    COLUMNS: [
      {
        title: { value: ROWS.LICENSE },
        name: 'license'
      },
      {
        title: { value: ROWS.COMPONENTS },
        name: 'components',
        type: 'number'
      },
      {
        title: { value: ROWS.VENDORS },
        name: 'vendors',
        type: 'number'
      },
      {
        title: { value: ROWS.CVES },
        name: 'vulnerability',
        hideFilter: true
      },
      {
        title: { value: ROWS.EXPLOITS },
        name: 'exploit',
        hideFilter: true
      }
    ]
  },
  type: {
    COLUMNS: [
      {
        title: { value: ROWS.TYPE },
        name: 'type',
        type: 'multiselect',
        filterValues: SBOM_CONSTANTS.TYPE_COLUMN_FILTER_VALUES
      },
      {
        title: { value: ROWS.COMPONENTS },
        name: 'components',
        type: 'number'
      },
      {
        title: { value: ROWS.LICENSES },
        name: 'licenses',
        type: 'number'
      },
      {
        title: { value: ROWS.CVES },
        name: 'vulnerability',
        hideFilter: true
      },
      {
        title: { value: ROWS.EXPLOITS },
        name: 'exploit',
        hideFilter: true
      }
    ]
  },
  subtype: {
    COLUMNS: [
      {
        title: { value: ROWS.PACKAGE_MANAGER },
        name: 'subtype'
      },
      {
        title: { value: ROWS.COMPONENTS },
        name: 'components',
        type: 'number'
      },
      {
        title: { value: ROWS.VENDORS },
        name: 'vendors',
        type: 'number'
      },
      {
        title: { value: ROWS.CVES },
        name: 'vulnerability',
        hideFilter: true
      },
      {
        title: { value: ROWS.EXPLOITS },
        name: 'exploit',
        hideFilter: true
      }
    ]
  }
};
